<template>
    <bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">
          <component  :is="currentTab" :currentTab='currentTab'></component>
    </bsp-tabs>
</template>
<script>
 import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs";
 import privateRefundList from "@/views/wage/refund/privateRefundList";
  export default {
    data() {
      return {
        tabList: [ {
            title: '对私退票',
            name: 'private'
        }],
        tabIndex: 'private',
        currentTab:'private',
      }
    },
    components:{
        bspTabs,
        private: privateRefundList,

    },
    methods: {
      changeTab(tab, event) {
          this.currentTab = tab.name;
      }
    }
  }
</script>
